import { createAction } from "@ngrx/store";
import { IAdmin } from "../../models/admin/admin.model";

export const loadCurrentAdmin = createAction(
  '[Admin] Load Current Admin',
  (admin: IAdmin) => ({admin})
);
